import { CustomValidators } from 'app/shared/utils/validators.utils';
import { BaseEntity } from '../baseEntity.model';
import { Parameter } from '../parameters/parameter.model';
import { Validators } from '@angular/forms';

export class TeraComponent extends BaseEntity {
  appComponentId: string = '';
  isSica: boolean = false;
  
  name: string = '';
  title: string = '';
  description: string = '';
  icon: string = '';
  link: string = '';
  
  componentType: Parameter = null;
  componentTypeId: string = null;
  teraComponentParent: TeraComponent = null;
  teraComponentParentId: string;
  
  order: number = 0;
  hierarchicalPath: string; // used for sorting

  constructor(init?: Partial<TeraComponent>) {
    super(); // Appel du constructeur de la classe parente, si nécessaire
    Object.assign(this, init);
  }

  // Méthode pour obtenir les validateurs
  static getValidators(key: string) {
    const validators = [];
    switch (key) {
      case 'appComponentId':
      case 'name':
        validators.push(Validators.required);
        validators.push(CustomValidators.noWhitespaceValidator);
        break;

      case 'componentType':
      case 'teraComponentParent':
        validators.push(CustomValidators.validateData);
        break;
      // Ajoutez d'autres cas selon vos besoins
      default:
        break;
    }
    return validators;
  }
}
